import { GenericBulkUpsertEffects } from './generic-bulk-upsert.effects';

export const effects: any[] = [GenericBulkUpsertEffects];

export * from './generic-bulk-upsert.effects';